import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { Injectable, inject } from '@angular/core';

import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Store } from '@ngxs/store';

import { ExternalUnit, UnitSimulationAccessory } from '../../models';
import { UnitConfigurationActions } from './unit-configuration.actions';
import { UnitConfigurationSelectors } from './unit-configuration.selectors';

@Injectable({
  providedIn: 'root',
})
export class UnitConfigurationFacade {
  private store = inject(Store);

  updatingAccessories$ = this.store.select(UnitConfigurationSelectors.getUpdatingAccessories);

  currentSimulationAccessories$ = this.store.select(UnitConfigurationSelectors.getCurrentSimulationAccessories);
  externalUnits = this.store.selectSignal(UnitConfigurationSelectors.getExternalUnits);
  isExternalUnitsLoading$ = this.store
    .select(UnitConfigurationSelectors.isExternalUnitsLoading)
    .pipe(debounceTime(150), distinctUntilChanged());

  @Dispatch()
  setSimulationAccessories = (accessories: UnitSimulationAccessory[] | undefined) =>
    new UnitConfigurationActions.SetSimulationAccessory(accessories);

  @Dispatch()
  setUpdatingAccessories = (updating: boolean) => new UnitConfigurationActions.SetUpdatingAccessories(updating);

  @Dispatch()
  loadExternalUnits = () => new UnitConfigurationActions.LoadExternalUnits();

  @Dispatch()
  setExternalUnits = (externalUnits: ExternalUnit[]) => new UnitConfigurationActions.SetExternalUnits(externalUnits);

  @Dispatch()
  resetExternalUnitsState = () => new UnitConfigurationActions.ResetExternalUnitsState();

  @Dispatch()
  clearState = () => new UnitConfigurationActions.ClearState();
}
